export const resolveFetch = customFetch => {
  let _fetch;
  if (customFetch) {
    _fetch = customFetch;
  } else if (typeof fetch === 'undefined') {
    _fetch = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return import('@supabase/node-fetch').then(_ref => {
        let {
          default: fetch
        } = _ref;
        return fetch(...args);
      });
    };
  } else {
    _fetch = fetch;
  }
  return function () {
    return _fetch(...arguments);
  };
};